<template>
      <div class="row center">

          <div v-show="!loading" class="col-md-12 center">

            <div id="card-element"><!-- A Stripe Element will be inserted here. --></div>
            <div v-if="error" role="alert">{{error}}</div>

            <div class="row padd30t">
              <div class="col-md-12">
                <button 
                  type="submit"
                  @click.prevent="submit"
                  class="btn btn-default btn-slot btn-block">
                    {{__('webapp.step3_button')}} <i class="fa fa-chevron-circle-right"></i>
                    <div class="ld ld-ring ld-spin"></div>
                </button>
              </div>
            </div>
          </div>
          <div v-show="loading">
            loading...
          </div>

        </div>
</template>
<script>

export default {
    data: function(){
        return {
          loading: false,
          stripe: null,
          error: '',
          paymentIntentSecret: null,
          card: null,
          clientId: null,
          style:{
            base: {
              color: '#32325d',
              lineHeight: '18px',
              fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
              fontSmoothing: 'antialiased',
              fontSize: '18px',
              '::placeholder': {
                color: '#aab7c4'
              }, 
            },
            invalid: {
              color: '#fa755a',
              iconColor: '#fa755a'
            }
          }
        }
    },
    props:{
      amount: [String,Number],
      fullname: String,
      email: String,
    },
    methods:{
      async submit(){
        this.loading = true;
        const {paymentIntent, error} = await this.stripe.confirmCardPayment(this.paymentIntentSecret, {
            payment_method: {
              card: this.card, 
              billing_details: this.fullname
            }
          });
        this.loading = false;
        if(!error){
          this.$emit('submit',paymentIntent.id)
        }else{
          console.log(error);
          if(error.paymentIntent.status == 'requires_capture'){
            this.$emit('submit',paymentIntent.id)
          }
        }
      }
    },
    mounted(){
      var self = this;
      this.loading = true;
      $.ajax({
        type: 'POST',
        url: route('webapp.stripe.payment-intent',window.company_alias),
        data:{
          amount   : this.amount,
          fullname : this.fullname,
          email    : this.email
        },
        success(response){
          self.paymentIntentSecret = response.payment_intent_secret;
          self.stripe = Stripe("config('app.STRIPE_KEY')", {
            stripeAccount: response.client_id
          });

          self.card = self.stripe.elements().create('payment', {style: this.style});
          
          self.card.mount('#card-element');
          self.card.addEventListener('change', function(event) {
            if(event.error)
              self.error = event.error.message;
            else
              self.error = '';
          });
        },
        complete(){
          self.loading = false;
        }
      })
    }
}
</script>

<style scoped>

</style>
